import { Percentage } from '@/domain/types/NumericValues'

interface UseUsdxlPoolAprBreakdownParams {
  balancerApy: number
}

interface UseUsdxlPoolAprBreakdownResult {
  totalApr: Percentage
  balancerBaseApr: Percentage
}

export function useUsdxlPoolAprBreakdown({
  balancerApy,
}: UseUsdxlPoolAprBreakdownParams): UseUsdxlPoolAprBreakdownResult {
  const balancerPoolApr = Percentage(balancerApy, true)

  return {
    totalApr: balancerPoolApr,
    balancerBaseApr: balancerPoolApr,
  }
}
